import { authenticationChannel } from '@codametrix/ui-common';
import { persistSessionState, SESSION_STATE_KEY } from '../store/persist-session-state';

/**
 * Persist session state and reload after org switch. Called from jumpContext once
 * API work and in-app navigation are complete — not from beforeunload.
 */
export function finalizeContextSwitchReload(
  getState: () => CMx.ApplicationState,
  reload: () => void = () => window.location.reload()
): void {
  persistSessionState(getState(), 'context-switch');
  authenticationChannel.close();
  sessionStorage.removeItem('channel');
  reload();
}

/**
 * Another tab switched org and broadcast SESSION_ORG_CONTEXT_SWITCHED. This
 * tab's own sessionStorage snapshot (if any) reflects its own last state, not
 * the org the broadcast is telling it about — clear it before the hard
 * navigation below, so the reload's bootstrap can't mistake that stale
 * snapshot for a trusted same-tab context-switch restore and skip the real
 * GET /contexts/v1 fetch.
 */
export function handleOrgContextSwitched(
  navigate: () => void = () => {
    window.location.href = '/cmx/';
  }
): void {
  window.sessionStorage.removeItem(SESSION_STATE_KEY);
  window.sessionStorage.removeItem('authToken');
  navigate();
}
